import { CommonEnums } from '../../common.enums';

export class Splt_Inst_Cnd {
    splt_Inst_Cnd_Id: number;
    splt_Inst_Id: number;
    dxMp_Id: number;
    spltCndNm: string;
    spltCnd: string;
    valid_Cd: string;
    srt_Order: number;

    constructor() {
        this.setDefault();
    }

    setDefault() {
        this.splt_Inst_Cnd_Id = CommonEnums.defaults.LONG_VAL;
        this.splt_Inst_Id = CommonEnums.defaults.LONG_VAL;
        this.dxMp_Id = CommonEnums.defaults.LONG_VAL;
        this.spltCndNm = CommonEnums.defaults.STRING_EMPTY;
        this.spltCnd = CommonEnums.defaults.STRING_EMPTY;
        this.valid_Cd = CommonEnums.defaults.STRING_EMPTY;
        this.srt_Order = CommonEnums.defaults.LONG_VAL;
    }

    static parse(splt_Inst_CndTmp: Splt_Inst_Cnd): Splt_Inst_Cnd {
        let splt_Inst_Cnd: Splt_Inst_Cnd = new Splt_Inst_Cnd();
        splt_Inst_Cnd.copyFrom(splt_Inst_CndTmp);
        return splt_Inst_Cnd;
    }

    getPrimaryKey(): string {
        return this.splt_Inst_Id + '.' + this.dxMp_Id;
    }

    copy(): Splt_Inst_Cnd {
        let splt_Inst_CndTmp: Splt_Inst_Cnd = new Splt_Inst_Cnd();

        splt_Inst_CndTmp.splt_Inst_Cnd_Id = this.splt_Inst_Cnd_Id;
        splt_Inst_CndTmp.splt_Inst_Id = this.splt_Inst_Id;
        splt_Inst_CndTmp.dxMp_Id = this.dxMp_Id;
        splt_Inst_CndTmp.spltCndNm = this.spltCndNm;
        splt_Inst_CndTmp.spltCnd = this.spltCnd;
        splt_Inst_CndTmp.valid_Cd = this.valid_Cd;
        splt_Inst_CndTmp.srt_Order = this.srt_Order;

        return splt_Inst_CndTmp;
    }

    copyFrom(splt_Inst_CndTmp: Splt_Inst_Cnd): void {
        this.splt_Inst_Cnd_Id = splt_Inst_CndTmp.splt_Inst_Cnd_Id;
        this.splt_Inst_Id = splt_Inst_CndTmp.splt_Inst_Id;
        this.dxMp_Id = splt_Inst_CndTmp.dxMp_Id;
        this.spltCndNm = splt_Inst_CndTmp.spltCndNm;
        this.spltCnd = splt_Inst_CndTmp.spltCnd;
        this.valid_Cd = splt_Inst_CndTmp.valid_Cd;
        this.srt_Order = splt_Inst_CndTmp.srt_Order;
    }

    compare(splt_Inst_CndTmp: Splt_Inst_Cnd): string {
        let splt_Inst_CndString: string = this.toString(false);
        let splt_Inst_CndTmpString: string = splt_Inst_CndTmp.toString(false);

        if (splt_Inst_CndString != splt_Inst_CndTmpString) {
            return splt_Inst_CndString + ', ' + splt_Inst_CndTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Splt_Inst_Cnd [splt_Inst_Cnd_Id=" + this.splt_Inst_Cnd_Id + ", splt_Inst_Id=" + this.splt_Inst_Id +
            ", dxMp_Id=" + this.dxMp_Id + ", spltCndNm=" + this.spltCndNm + ", spltCnd=" + this.spltCnd +
            ", valid_Cd =" + this.valid_Cd + ", srt_Order =" + this.srt_Order ;

        if (isNotCompare) {
            str += ''
        }

        str += ']';

        return str;
    }
}